<template>
  <div class="anime_loading">
    <div class="fullbox_cont">
      <div class="loading-container">
        <div class="loading"></div>
        <div class="loading-text">{{ $t('loading.loading') }}</div>
      </div>
      <p>{{ loadingText }}</p>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {};
  },
  props: ['loadingText']
};
</script>

<style lang="scss" scoped>
.anime_loading {
  background: rgba($black, 1);
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10000;
  min-height: 100vh;
}

.loading-container,
.loading {
  height: 100px;
  position: relative;
  width: 100px;
  border-radius: 100%;
}

.loading {
  border: 2px solid transparent;
  border-color: transparent $main_color transparent $main_color;
  animation: rotate-loading 1.5s linear 0s infinite normal;
  transform-origin: 50% 50%;
}

.loading-container:hover .loading {
  border-color: transparent $sec_color transparent $sec_color;
}

.loading-container:hover .loading,
.loading-container .loading {
  transition: all 0.5s ease-in-out;
}

.loading-text {
  animation: loading-text-opacity 2s linear 0s infinite normal;
  color: $white;
  @include rem(font-size, 1rem);
  margin-top: 45px;
  opacity: 0;
  position: absolute;
  text-align: center;
  text-transform: uppercase;
  top: 0;
  width: 100px;
}

p {
  color: $white;
  text-align: center;
  margin-top: 20px;
}
</style>
